import { render, staticRenderFns } from "./mbFugaiswipered.vue?vue&type=template&id=35ba9dfd&scoped=true&"
import script from "./mbFugaiswipered.vue?vue&type=script&lang=js&"
export * from "./mbFugaiswipered.vue?vue&type=script&lang=js&"
import style0 from "./mbFugaiswipered.vue?vue&type=style&index=0&id=35ba9dfd&scoped=true&lang=css&"
import style1 from "./mbFugaiswipered.vue?vue&type=style&index=1&id=35ba9dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba9dfd",
  null
  
)

export default component.exports